import { GridContainer } from 'libs/ui';
import { Promises } from 'grids/promises/promises';

export const PromisesWrapper = (props) => {
  return (
    <GridContainer>
      <Promises {...props} />
    </GridContainer>
  );
};
